import React from "react";
import { ReactDataGrid } from "rhombus-react";

const { Row } = ReactDataGrid;

export class DisabledExistingCreativesRenderer extends React.Component {

	setScrollLeft = (scrollBy) => {
		this.row.setScrollLeft(scrollBy);
	};

	render() {
		// using my custom row
		const { canSelect } = this.props.row
		 , extraClasses = !canSelect ? 'disabled' : '';
		 return (
			<Row ref={node => this.row = node} {...this.props}
				isSelected={this.props.row.isSelected}
				extraClasses={extraClasses} />
		 );
	}
}
